module.exports = __webpack_public_path__ + "static/media/U1-T2-2-1.72ae2336.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/U1-T2-2-1.png
// module id = 538
// module chunks = 0